export default __webpack_public_path__ + "static/media/Angular.ad76c6df.pdf";